export default __webpack_public_path__ + "static/media/logo.7d9595e4.jpg";